module.exports = __webpack_public_path__ + "img/Info.d4dbee87.svg";